// localizaton
import ARM from '../../assets/images/localization/arm.svg';
import RUS from '../../assets/images/localization/rus.svg';
import ENG from '../../assets/images/localization/eng.svg';

const Languages = [{ value: 'ՀԱՅ', img: ARM, id: 0 }, { value: 'РУС', img: RUS, id: 1 }, { value: 'ENG', img: ENG, id: 2 }];
export default function(state = Languages, action) {
  return state;
}
